import { useNavigate, useParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'
import { MandatoryProcessTasksQuery } from 'generated/resources/datatable.graphql'

import { useDataTable } from 'modules/core/components/DataTable'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useBulkResolveOverviewTasks } from 'modules/processes/hooks/tasks/useBulkResolveOverviewTasks'
import { TaskIdentifier } from 'modules/tasks/lib/task'

import { useProcessOverviewTasks } from './ProcessOverviewTasksProvider'

export const DataTableActions = () => {
  const dataTable = useDataTable<MandatoryProcessTasksQuery>()
  const selectedTasks = [...dataTable.selectedRows].map((v) => String(v))

  const { setTaskIds } = useProcessOverviewTasks()

  const navigate = useNavigate()

  const { navigation } = useNavigation()
  const { category, id } = useParams()

  const { resolveTasks } = useBulkResolveOverviewTasks()

  const { performAction: bulkResolveTasks } = useAsyncAction(
    async () => {
      await resolveTasks({
        variables: { ids: selectedTasks, done: true, identifier: TaskIdentifier.Workflow },
        refecthVars: { ...dataTable.variables },
      })
    },
    {
      errorFlash: true,
      successFlash: true,
      successFlashTime: 1000,
      loadingMessage: i18n.t('common.saving'),
    }
  )

  const handler = async (execute: () => void) => {
    if (!selectedTasks.length)
      return app.setFlash({
        type: 'wrong',
        message: i18n.t('processes.process.overview.tasks_table.reminder.empty'),
      })

    execute()
  }

  const handleCompleteTasks = async () => {
    handler(async () => {
      bulkResolveTasks()
    })
  }

  const handleTaskReminder = async () => {
    handler(() => {
      if (category && id) {
        setTaskIds(selectedTasks)
        navigate(
          navigation.processes.template.id.overview.sendReminder.fullPath({
            category,
            id,
          })
        )
      }
    })
  }

  return (
    <>
      <Button type="secondary" onClick={handleCompleteTasks} iconName="check">
        {i18n.t('processes.process.overview.tasks_table.complete_tasks')}
      </Button>
      <Button type="secondary" onClick={handleTaskReminder} iconName="bell">
        {i18n.t('processes.process.overview.tasks_table.reminder.cta')}
      </Button>
    </>
  )
}
